<div class="form-group">
  <label for="selectOrganization">
    <span translate>Select organization</span>
    @if (isLoadingOrganizations ) {
      <span
      class="fa-solid fa-spinner fa-spin ml-2"></span>
    }
  </label>
  <ng-select (change)="onChangeOrganization();"
    [(ngModel)]="organizationId" [clearable]="false"
    [items]="organizationsList"
    [loading]="isLoadingOrganizations"
    bindLabel="name"
    bindValue="id" id="selectOrganization"
    [placeholder]="'Select organization ...' | translate"
    [title]="'Choose tenant ...' | translate">
  </ng-select>
</div>

<div class="form-group">
  <label>
    <span translate>Select machines </span>
    @if (isLoadingMachinesOfOrganization ) {
      <span
      class="fa-solid fa-spinner fa-spin ml-2"></span>
    }
  </label>

  <ng-select (change)="onUpdateSelectedMachines()"
    [(ngModel)]="selectedMachinesList"
    [closeOnSelect]="false"
    [items]="machinesList"
    [multiple]="true"
    [searchable]="true"
    [placeholder]="'Select machines ...' | translate"
    bindLabel="type" [compareWith]="compareMachines"
    id="machineSelect" name="machineSelect">
    <ng-template ng-header-tmp>
      <div class="form-row align-items-center">
        <div class="col-6">
          <button (click)="onSelectAll()" class="btn btn-outline-primary btn-sm btn-block" translate>Select all
          </button>
        </div>
        <div class="col-6">
          <button (click)="onClearAll()" class="btn btn-outline-primary btn-sm btn-block" translate>Clear
          </button>
        </div>
      </div>
    </ng-template>
    <ng-template let-item="item" ng-option-tmp>
      <div><span [innerText]="item.type"></span></div>
      <small [innerText]="item.category"></small>
    </ng-template>
  </ng-select>
</div>


@if (!selectedMachinesList || selectedMachinesList.length === 0) {
  <div class="alert alert-info" translate>
    Currently no target machines are added, please add from above list.
  </div>
}
